import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { HelmetProvider } from "react-helmet-async";
import { store } from "./store";
import { Provider } from "react-redux";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { loadTrackingScripts } from "./utils/websiteAnalytics";

loadTrackingScripts();
// serviceWorkerRegistration.register();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <React.StrictMode>
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </React.StrictMode>
  </Provider>
);

// 🧠 Safe Service Worker Unregister-Then-Register
if ("serviceWorker" in navigator) {
  // console.log("Inside here");
  window.addEventListener("load", () => {
    // console.log("Loading");
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      for (let reg of registrations) {
        console.log("Unregistering");
        reg.unregister(); // 🧹 Clean old service workers
      }

      // ✅ Now register the current one after cleanup
      // console.log("Just before the register");
      serviceWorkerRegistration.register();
    });
  });
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
